import {
    AlignItems,
    Col,
    Column,
    Container,
    Gap,
    JustifyContent,
    Row,
    Stack,
    StackBehavior,
    StackDirection,
    StackWrap,
    Text,
    Wrapper
} from "@rebootui";

import LandingBg from "../../assets/images/landing-bg.png";
import Icon from "../common/Icon";
import { Link } from "react-router-dom";
const Landing = () => {
    return (
        <>
            <Stack alignItems={AlignItems.Center} className="landing vh-100 position-relative">
                <Wrapper className="position-absolute top-0 start-0 w-100 h-100 zi-99">
                    <img
                        src={LandingBg}
                        alt=""
                        className="object-fit-cover w-100 h-100"
                    />
                </Wrapper>
                <Container className="position-relative zi-99">
                    <Row justifyContent={JustifyContent.Center} className="text-center">
                        <Column col={Col.Col12}>
                            <Stack behavior={StackBehavior.InlineFlex} alignItems={AlignItems.Center} gap={Gap.Gap2} className="text-dark px-4 py-2 bg-dark bg-opacity-10 border border-dark border-opacity-20 rounded-pill mb-l small">
                                <Icon name="bullet" width={8} height={8} className="opacity-50" />
                                Now Available: Version 1.0.12
                            </Stack>
                            <Text className="h1 mb-4 px-md-5 mb-4">Beautiful React Components Built on Bootstrap</Text>
                        </Column>
                        <Column col={[Col.Col12, Col.ColMd10, Col.ColLg9]}>
                            <Text el="p" className="fs-4 mb-xl text-secondary">
                                RebootUI is a lightweight React component library built on Bootstrap.
                                Create clean, responsive, production-ready interfaces with minimal
                                setup.
                            </Text>
                            <Stack wrap={StackWrap.Wrap} justifyContent={JustifyContent.Center} gap={Gap.Gap3} className="mb-6">
                                <Stack.Item>
                                    <Link className="btn btn-sm btn-dark text-white shadow-l rounded-4" to="/docs">Get Started</Link>
                                </Stack.Item>
                                <Stack.Item>
                                    <Link className="btn btn-sm btn-light border border-black border-opacity-10 rounded-4" to="/docs/components">View Components</Link>
                                </Stack.Item>
                                <Stack.Item>
                                    <Link className="btn btn-sm btn-light lh-130 px-3 d-flex align-items-center gap-2 border border-black border-opacity-10 rounded-4" to="/">
                                        <Icon name="github" width={20} height={20} />
                                        Github
                                    </Link>
                                </Stack.Item>
                            </Stack>
                            <Stack justifyContent={JustifyContent.Center} gap={[Gap.Gap4, Gap.GapMd5]}>
                                <Stack direction={StackDirection.Column} alignItems={AlignItems.Center} gap={Gap.Gap2}>
                                    <Text className="h3 mb-0">50+</Text>
                                    <Text el="p" className="small text-secondary mb-0">Components</Text>
                                </Stack>
                                <Stack direction={StackDirection.Column} alignItems={AlignItems.Center} gap={Gap.Gap2}>
                                    <Text className="h3 mb-0">2000+</Text>
                                    <Text el="p" className="small text-secondary mb-0">Icons</Text>
                                </Stack>
                                <Stack direction={StackDirection.Column} alignItems={AlignItems.Center} gap={Gap.Gap2}>
                                    <Text className="h3 mb-0">100+</Text>
                                    <Text el="p" className="small text-secondary mb-0">Accessible</Text>
                                </Stack>
                                <Stack direction={StackDirection.Column} alignItems={AlignItems.Center} gap={Gap.Gap2}>
                                    <Text className="h3 mb-0">500KB</Text>
                                    <Text el="p" className="small text-secondary mb-0">Zipped</Text>
                                </Stack>
                            </Stack>
                        </Column>
                    </Row>
                </Container>
            </Stack>
        </>



    )
};

export default Landing;
